export const CATEGORIES_ENDPOINT =
  '/p/v3/kb/categories?pageSize=1000&page=:page';

export const CATEGORY_ENDPOINT = '/p/v3/kb/categories/:id';

export const ROOT_CATEGORY_ENDPOINT = '/p/v3/kb/categories/root';
